import { render, staticRenderFns } from "./ScanMetadata.vue?vue&type=template&id=2ca75e2a&"
import script from "./ScanMetadata.vue?vue&type=script&lang=js&"
export * from "./ScanMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports